/* eslint-disable camelcase */
import React, { useContext, useEffect, useState } from 'react'
import { Container, Footer, Form } from './styled'
import { Button } from '../../../../components/common/Button'
import { MultiSelect } from '../../../../components/MultiSelect'
import { SideTab } from '../../../../components/SideTab'
import { Input } from '../../../../components/common/Input'
import api from '../../../../services/api'
import { useSocket } from '../../../../context/socketProvider'
import { Modal } from '../../../../components/Modal'

export const NewOcurrence = ({ setCloseAll }) => {
  const [selectedOptions, setSelectedOptions] = useState([])
  const [selectedSecurityOptions, setSelectedSecurityOptions] = useState([])
  const [resumeIsOpen, setResumeIsOpen] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [baseList, setBaseList] = useState([])
  const [securityList, setSecurtiyList] = useState([])
  const [textAreaValue, setTextAreaValue] = useState('')

  const [selectedBaseIds, setSelectedBaseIds] = useState([])
  const [selectedUserIds, setSelectedUsersIds] = useState([])

  const { socket } = useSocket()

  const id = localStorage.getItem('id_user')

  const hasSendButtonEnabled = () => {
    return (
      selectedBaseIds.length <= 0 ||
      selectedUserIds.length <= 0 ||
      textAreaValue.length <= 0
    )
  }

  const getBaseList = () => {
    api.get('/v1/dashboard/home/base-list').then((response) => {
      const data = response.data
      const transformedOptions = data.map((item) => ({
        id: item.id,
        value: item.outpost,
        label: item.outpost,
      }))

      setBaseList(transformedOptions)
    })
  }

  const getSecurityList = () => {
    api
      .get('/v1/dashboard/home/employees-list', {
        params: {
          id_base: selectedBaseIds,
        },
      })
      .then((response) => {
        const data = response.data
        const transformedOptions = data.map((item) => ({
          id_user: item.id_user,
          value: item.name,
          label: item.name,
        }))
        setSecurtiyList(transformedOptions)
      })
  }

  useEffect(() => {
    getBaseList()
    getSecurityList()
    hasSendButtonEnabled()
  }, [selectedBaseIds])

  const handleSecurityMultiSelectChange = (selected) => {
    const selectAllOption = selected.find((option) => option.value === '*')

    if (selectAllOption) {
      setSelectedSecurityOptions(securityList)
      const allIds = securityList.map((option) => option.id_user)
      setSelectedUsersIds(allIds)
    } else {
      const selectedIds = selected.map((option) => option.id_user)

      const uniqueIds = [...new Set(selectedIds)]

      setSelectedSecurityOptions(selected)
      setSelectedUsersIds(uniqueIds)
    }
  }

  const handleBaseMultiSelectChange = (selected) => {
    const selectAllOption = selected.find((option) => option.value === '*')

    if (selectAllOption) {
      // Selecionar todas as opções disponíveis
      setSelectedOptions(baseList)
      const allIds = baseList.map((option) => option.id)
      setSelectedBaseIds(allIds)
    } else {
      const selectedIds = selected.map((option) => option.id)

      const uniqueIds = [...new Set(selectedIds)]

      setSelectedOptions(selected)
      setSelectedBaseIds(uniqueIds)
    }
  }

  const handleSendNotifications = () => {
    const payload = {
      id_base: selectedBaseIds,
      id_user: selectedUserIds,
      id_adm: id,
      message: textAreaValue,
    }
    socket.emit('notifications:occurrences', payload)
  }
  return (
    <>
      <Container>
        <span>
          Envie mensagens rápidas para os funcionários, informando sobre as
          ocorrências abertas, com o objetivo de reduzir o quadro de pendências
          em relação aos moradores.
        </span>

        <Form
          onSubmit={(e) => {
            e.preventDefault()
          }}
        >
          <p>Digite o texto da notificação</p>
          <textarea
            name=""
            value={textAreaValue}
            id=""
            cols={30}
            rows={10}
            onChange={(e) => setTextAreaValue(e.target.value)}
          />

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '10px',
            }}
          >
            <div
              style={{
                flex: 1,
              }}
            >
              <MultiSelect
                selectedOptionsProp={selectedOptions}
                options={baseList}
                onChangeProp={handleBaseMultiSelectChange}
                placeholder="Selecionar base"
              />
            </div>
            <div
              style={{
                flex: 1,
              }}
            >
              <MultiSelect
                selectedOptionsProp={selectedSecurityOptions}
                options={securityList}
                onChangeProp={handleSecurityMultiSelectChange}
                placeholder="Selecionar seguranças"
              />
            </div>
          </div>
          <Footer>
            <Button.Root
              backgroundColor="#308EC6"
              type="button"
              onClick={() => setResumeIsOpen((prev) => !prev)}
              disabled={hasSendButtonEnabled()}
            >
              <Button.Content title="Enviar notificação" color="#fff" />
            </Button.Root>
          </Footer>
        </Form>
      </Container>

      <SideTab
        open={resumeIsOpen}
        toggleFunction={() => setResumeIsOpen((prev) => !prev)}
        title="Resumo"
        width="100%"
      >
        <Container>
          <span>
            Veja as informações que você está enviando e confirme quem vai
            receber as informações:
          </span>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
            }}
          >
            <textarea
              disabled
              name=""
              id=""
              value={textAreaValue}
              cols={30}
              rows={10}
            ></textarea>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                overflow: 'auto',
                maxHeight: '20rem',
              }}
            >
              <span>Bases selecionadas</span>
              {selectedOptions.map((option, index) => (
                <>
                  <Input.Root key={index}>
                    <Input.Label title="" htmlFor="" color="" fontSize="14px" />
                    <Input.Wrapper
                      borderColor="#CECECE"
                      backgroundColor="#F7F7F7"
                      outlineColor=""
                    >
                      <Input.Content
                        id=""
                        disabled
                        type="text"
                        placeholder=""
                        value={option.value}
                        name=""
                      />
                    </Input.Wrapper>
                  </Input.Root>
                </>
              ))}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                overflow: 'auto',
                maxHeight: '20rem',
              }}
            >
              <span>Seguranças selecionados</span>
              {selectedSecurityOptions.map((option, index) => (
                <>
                  <Input.Root key={index}>
                    <Input.Label title="" htmlFor="" color="" fontSize="14px" />
                    <Input.Wrapper
                      borderColor="#CECECE"
                      backgroundColor="#F7F7F7"
                      outlineColor=""
                    >
                      <Input.Content
                        id=""
                        disabled
                        type="text"
                        placeholder=""
                        value={option.value}
                        // onChange={handleChange}
                        name=""
                      />
                    </Input.Wrapper>
                  </Input.Root>
                </>
              ))}
            </div>

            <Footer>
              <Button.Root
                backgroundColor="#308EC6"
                type="button"
                onClick={() => {
                  handleSendNotifications()
                  setCloseAll()
                }}
              >
                <Button.Content title="Confirmar envio" color="#fff" />
              </Button.Root>
            </Footer>
          </Form>
        </Container>
      </SideTab>
    </>
  )
}
